export const SET_REGISTER_DATA = "SET_REGISTER_DATA";
export const SET_LOGIN_DATA = "SET_LOGIN_DATA";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const SHOW_TOAST_MESSAGE = "SHOW_TOAST_MESSAGE";
export const HIDE_TOAST_MESSAGE = "HIDE_TOAST_MESSAGE";
export const RESET_STORE = "RESET_STORE";
export const SET_CURRENT_NAME = "SET_CURRENT_NAME";
export const SET_DEFAULT_TAPROOT_CURRENCY = "SET_DEFAULT_TAPROOT_CURRENCY";
export const SET_DEFAULT_WALLET_CURRENCY = "SET_DEFAULT_WALLET_CURRENCY";
export const SET_TRANSACTION_FILTER_DATA = "SET_TRANSACTION_FILTER_DATA";
export const SET_ACCOUNT_RESTRICTED_MODAL_DATA =
  "SET_ACCOUNT_RESTRICTED_MODAL_DATA";
export const SET_ACCOUNT_CURRENCY = "SET_ACCOUNT_CURRENCY";
export const SET_SHOW_BTC_AMOUNT = "SET_SHOW_BTC_AMOUNT";
export const SET_MAINTENANCE_MODAL_OPEN = "SET_MAINTENANCE_MODAL_OPEN";
export const SET_MAINTENANCE_FLAG = "SET_MAINTENANCE_FLAG";
export const SET_IS_HIDE_UNDER_MAINTENANCE_BAR =
  "SET_IS_HIDE_UNDER_MAINTENANCE_BAR";
export const SET_PAY_VIA_METHODS = "SET_PAY_VIA_METHODS";
export const SET_OPEN_APP_DETAIL_MODAL = "SET_OPEN_APP_DETAIL_MODAL";
export const SET_APP_DETAILS = "SET_APP_DETAILS";
export const SET_IS_OPEN_INSTALLED_APP_DIALOG =
  "SET_IS_OPEN_INSTALLED_APP_DIALOG";
export const SET_MY_APPS_DATA = "SET_MY_APPS_DATA";
export const SET_COLLECTION_DATA = "SET_COLLECTION_DATA";
export const SET_CATEGORY_DATA = "SET_CATEGORY_DATA";
export const SET_APP_LIST = "SET_APP_LIST";
export const SET_NEW_ADDRESS_OBJ = "SET_NEW_ADDRESS_OBJ";
export const SET_SEND_TO_CONTACT_DATA = "SET_SEND_TO_CONTACT_DATA";
